import { apiFetch, apiUpload } from './client';
import type { ImportCommitResult, ImportPreview } from '$lib/types';

// Spreadsheet import wizard (see ImportWizard.svelte). preview() parses +
// stashes the upload server-side (15-minute TTL, see internal/importer.Store)
// and returns a token; commit() consumes it. verticalId is a required form
// field for a multi-vertical caller (an admin) — same explicit-vertical rule
// as the rest of the app's write endpoints.
export const importApi = {
  preview: (file: File, verticalId?: number) => {
    const form = new FormData();
    form.append('file', file);
    if (verticalId !== undefined) form.append('vertical_id', String(verticalId));
    return apiUpload<ImportPreview>('/import/preview', form);
  },
  commit: (token: string, mapping: string[]) =>
    apiFetch<ImportCommitResult>('/import/commit', {
      method: 'POST',
      body: JSON.stringify({ token, mapping })
    })
};
